import clsx from 'clsx';
import React, { FC } from 'react';

export interface OverlayListItemProps {
  item: string | number;
  onClick: (item: string | number) => void;
  isSelected: boolean;
}

const OverlayListItem: FC<OverlayListItemProps> = ({
  item,
  onClick,
  isSelected,
}: OverlayListItemProps) => {
  const className = {
    item: 'flex h-[50px] p-[15px] items-center flex-row font-regular text-purple80 monochrome:text-grey90 leading-5 text-[14px]',
    default: 'bg-white',
    selected: 'bg-green60 monochrome:bg-grey10',
  };

  return (
    <li className="mt-[1px]">
      <div
        onClick={() => {
          onClick(item);
        }}
        className={clsx(
          className.item,
          isSelected ? className.selected : className.default
        )}
      >
        {item}
      </div>
    </li>
  );
};

export default OverlayListItem;
